/**
 *  pagingComposition.
 *
 */
import reportActionCreators from '../../actions/reportActionCreators';
import pagingComposition from '../common/pagingTable/pagingComposition';
export default pagingComposition(
// these are specific to issues.
'report',
// these describe the column to attribute mapping.  this is used for
// sending sorting queries to the server.
reportActionCreators);